@if (systemIntegrationResource.isLoading()) {
  <app-loading />
} @else {
  <app-system-recording-integration-panels
    [projectId]="projectId()"
    [currentOfficeSystemRecording]="currentOfficeSystemRecording()!"
    [targetOfficeSystemRecording]="targetOfficeSystemRecording()!"
    [integrationSystemRecordings]="integrationSystemRecordings()!"
  />
}
